import {paymentDestination} from './payment-navigation.mjs';
const limit = 16384;
const cleanText = (value,max,required=false) => {
  if (value == null && !required) return undefined;
  if(typeof value !== 'string' || value.length > max || /[\u0000-\u001f\u007f]/.test(value) || required && !value) throw new Error('Invalid external payment field');
  return value;
};
export function parseExternalPaymentLink(encoded,base) {
  if(typeof encoded !== 'string' || !encoded || encoded.length > limit || !/^[A-Za-z0-9+/_=-]+$/.test(encoded)) throw new Error('Invalid external payment link');
  const bytes=Uint8Array.from(atob(encoded.replace(/-/g,'+').replace(/_/g,'/')),c=>c.charCodeAt(0));
  let text;
  try {text=new TextDecoder('utf-8',{fatal:true}).decode(bytes);} catch {text=Array.from(bytes,c=>String.fromCharCode(c)).join('');}
  const input=JSON.parse(text);
  if(!input || Object.getPrototypeOf(input)!==Object.prototype || Array.isArray(input)) throw new Error('Invalid external payment link');
  const allowed=new Set(['key','amount','currency','title','desc','nonce','callback','trxID','products']);
  if(Object.keys(input).some(key=>!allowed.has(key))) throw new Error('Unknown external payment field');
  const key=cleanText(input.key,128,true);
  if(!/^[A-Za-z0-9_-]+$/.test(key)) throw new Error('Invalid application key');
  const amountText=typeof input.amount === 'number' ? String(input.amount) : input.amount;
  if(typeof amountText !== 'string' || !/^\d{1,12}(?:\.\d{1,2})?$/.test(amountText)) throw new Error('Invalid external amount');
  const amount=Number(amountText);
  if(!Number.isFinite(amount) || amount <= 0 || amount > 100000000000) throw new Error('Invalid external amount');
  const currency=input.currency ?? 'XAF';
  if(typeof currency !== 'string' || !/^[A-Z]{3}$/.test(currency)) throw new Error('Unsupported external currency');
  const output={key,amount,currency};
  for(const [field,max] of Object.entries({title:256,desc:2000,nonce:128,trxID:128})) {
    const value=cleanText(input[field],max);
    if(value !== undefined) {
      if(['nonce','trxID'].includes(field) && !/^[\x20-\x7e]*$/.test(value)) throw new Error('Invalid payment header field');
      output[field]=value;
    }
  }
  if(input.callback != null && input.callback !== '') output.callback=paymentDestination(input.callback,base).url;
  if(input.products != null) {
    if(!Array.isArray(input.products) || input.products.length > 100) throw new Error('Invalid external products');
    output.products=input.products.map(item=>{
      if(!item || Object.keys(item).some(key=>!['label','amount'].includes(key))) throw new Error('Invalid external product');
      const label=cleanText(item.label,256,true), price=String(item.amount);
      if(!/^\d{1,12}(?:\.\d{1,2})?$/.test(price) || Number(price)<=0 || Number(price)>100000000000) throw new Error('Invalid external product amount');
      return {label,amount:price};
    });
  }
  return output;
}
